import React from 'react';
import useSWR from 'swr';
import { Link } from 'react-router-dom';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

import PackageCardAlpha from "./../packageSidebar/PackageCardAlpha";

const scrollTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

function FrontpageSelection() {
  // API configuration constants
  const API_URL = `${process.env.REACT_APP_API_FOLDER}list_frontpage_selection/`;
  const API_TOKEN = process.env.REACT_APP_API_TOKEN;

  // Define a color mapping for the 10 artforms.
  const artformColors = {
    music: "#367591",
    sound: "#009FE3",
    film: "#FBF299",
    art: "#E6007E",
    environment: "#6EBC86",
    writing: "#7B6A58",
    activism: "#E24259",
    performance: "#725283",
    video: "#ABD194",
    vr: "#4D4C4C"
  };

  // Fetcher for SWR using native fetch and API token header
  const fetcher = (url) =>
    fetch(url, {
      headers: { "X-API-TOKEN": API_TOKEN }
    }).then((res) => {
      if (!res.ok) throw new Error(`Network response was not ok: ${res.status}`);
      return res.json();
    });

  // Use SWR for data fetching
  const { data, error, isLoading } = useSWR(API_URL, fetcher);

  // Derive state from fetched data
  const wsGroups = data ?? [];
  const allWorkshops = data?.allw ?? [];
  const onsiteWorkshops = data?.onsite ?? [];
  const onlineWorkshops = data?.online ?? [];

  // Skeleton loading state with placeholders
  if (isLoading) {
    return (
      <div className="package-area offer-package-style-one pt-110 pb-110">
        <div className="container">
          <div className="row d-flex justify-content-center g-4">
            {Array(6).fill().map((_, idx) => (
              <div key={idx} className="col-lg-4 col-md-6 fadeffect">
                <Skeleton height={350} />
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  // Error state
  if (error) {
    console.error("API Error:", error);
    return <div>Error loading data: {error.message}</div>;
  }

  // ALL WORKSHOPS
  const wsjsx_all = allWorkshops.map((workshop, idx) => (
    <div key={idx} className="col-lg-4 col-md-6 fadeffect">
      <PackageCardAlpha workshop={workshop} onClick={scrollTop} />
    </div>
  ));

  // ONSITE WORKSHOPS
  const wsjsx_onsite = onsiteWorkshops.map((workshop, idx) => (
    <div key={idx} className="col-lg-4 col-md-6 fadeffect">
      <PackageCardAlpha workshop={workshop} onClick={scrollTop} />
    </div>
  ));

  // ONLINE WORKSHOPS
  const wsjsx_online = onlineWorkshops.map((workshop, idx) => (
    <div key={idx} className="col-lg-4 col-md-6 fadeffect">
      <PackageCardAlpha workshop={workshop} onClick={scrollTop} />
    </div>
  ));

  return (
    <>
      <div className="package-area offer-package-style-one pt-110 pb-110">
        <div className="container">
          <div className="row d-flex justify-content-center align-items-center">
            <div className="col-lg-6 col-sm-10">
              <div className="section-head-alpha">
                <h2>Coming Up</h2>
                <p>Here's a taste of what's coming up at CAMP - <Link to="/workshops">click here</Link> to explore the full program.</p>
              </div>
            </div>
            <div className="col-lg-6 col-sm-10">
              <div className="package-btn text-lg-end">
                <Link to="/workshops" className="button-fill-primary all-package-btn">View all workshops</Link>
              </div>
            </div>
          </div>

          <div className="row align-items-center">
            <div className="offer-switch-button2">
              <ul className="nav nav-pills mb-3 justify-content-center gap-sm-4 gap-3" id="pills-tab" role="tablist">
                <li className="nav-item" role="presentation">
                  <button className="nav-link active" id="pills-all" data-bs-toggle="pill" data-bs-target="#pills-offer-tab1" type="button" role="tab" aria-controls="pills-offer-tab1" aria-selected="true">All</button>
                </li>
                <li className="nav-item" role="presentation">
                  <button className="nav-link" id="pills-onsite" data-bs-toggle="pill" data-bs-target="#pills-offer-tab2" type="button" role="tab" aria-controls="pills-offer-tab2" aria-selected="false">Onsite</button>
                </li>
                <li className="nav-item" role="presentation">
                  <button className="nav-link" id="pills-online" data-bs-toggle="pill" data-bs-target="#pills-offer-tab3" type="button" role="tab" aria-controls="pills-offer-tab3" aria-selected="false">Online</button>
                </li>
              </ul>
            </div>

            <div className="offer-single-tabs">
              <div className="tab-content" id="pills-tabContent">
                <div className="tab-pane fade show active" id="pills-offer-tab1" role="tabpanel" aria-labelledby="pills-offer1">
                  <div className="row d-flex justify-content-center g-4">
                    {wsjsx_all}
                  </div>
                  <div className="package-page-btn text-center mt-60">
                    <Link to="/workshops" className="button-fill-round">View all workshops</Link>
                  </div>
                </div>

                <div className="tab-pane fade" id="pills-offer-tab2" role="tabpanel" aria-labelledby="pills-offer2">
                  <div className="row d-flex justify-content-center g-4">
                    {wsjsx_onsite}
                  </div>
                  <div className="package-page-btn text-center mt-60">
                    <Link to="/workshops" className="button-fill-round">View all workshops</Link>
                  </div>
                </div>

                <div className="tab-pane fade" id="pills-offer-tab3" role="tabpanel" aria-labelledby="pills-offer3">
                  <div className="row d-flex justify-content-center g-4">
                    {wsjsx_online}
                  </div>
                  <div className="package-page-btn text-center mt-60">
                    <Link to="/workshops" className="button-fill-round">View all workshops</Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default FrontpageSelection;
